// extracted by mini-css-extract-plugin
module.exports = {"control":"LanguagePicker_control__VUaE2","label":"LanguagePicker_label__irRbx","icon":"LanguagePicker_icon__0EOqZ"};